import { MAIN_STAGE } from '../main-stage';
import type { SetDefinition } from '../types';
import { denserTiers, inCorners } from './stage-kit';

const AMBYSS_TICKS_PER_BEAT = 15;

export const AMBYSS: SetDefinition = {
  ...MAIN_STAGE,
  tiers: denserTiers(1.25),
  id: 'ambyss',
  trackIds: ['sous-la-voile', 'les-quatre-marches'],
  name: 'Ambyss',
  style: 'Psychill, ambient',
  ticksPerBeat: AMBYSS_TICKS_PER_BEAT,
  decor: 'ambyss',
  acoustics: { reverbSeconds: 4.5, wet: 0.5, lowCutHz: 220, toneHz: 5200 },
  speakers: inCorners(MAIN_STAGE.speakers),
};
